import React from 'react';
import useArticles from '../hooks/useArticles';
import ArticlesCtaSection from './articles/components/ArticlesCtaSection';
import ArticlesFiltersPanel from './articles/components/ArticlesFiltersPanel';
import ArticlesGrid from './articles/components/ArticlesGrid';
import ArticlesHeroSection from './articles/components/ArticlesHeroSection';
import ArticlesListHeader from './articles/components/ArticlesListHeader';
import { useArticlesFilters } from './articles/hooks/useArticlesFilters';

const Articles = () => {
  const { articles, status, error } = useArticles();
  const {
    filteredArticles,
    months,
    selectedMonth,
    selectedYear,
    setSelectedMonth,
    years,
    handleYearChange,
  } = useArticlesFilters(articles);

  return (
    <>
      <ArticlesHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          <section aria-labelledby="articles-list-title">
            <ArticlesListHeader />

            {status === 'loading' && (
              <div className="mt-12 text-center text-gray-600">Carregando artigos...</div>
            )}
            {status === 'error' && (
              <div className="mt-12 text-center text-red-600">
                {error || 'Nao foi possivel carregar os artigos agora.'}
              </div>
            )}
            {status === 'success' && (
              <>
                <ArticlesFiltersPanel
                  years={years}
                  selectedYear={selectedYear}
                  onYearChange={handleYearChange}
                  months={months}
                  selectedMonth={selectedMonth}
                  onMonthSelect={setSelectedMonth}
                />
                <ArticlesGrid filteredArticles={filteredArticles} />
              </>
            )}
          </section>

          <ArticlesCtaSection />
        </div>
      </div>
    </>
  );
};

export default Articles;
